/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import Modal from 'app/components/common/Modal.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import SelectorTools from 'app/utility/SelectorTools.js';
import ComboButton from 'app/components/common/ComboButton.jsx';
import PostPictureUpload from 'app/components/common/PostPictureUpload.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import SocialSelection from 'app/components/SocialModal/SocialSelection.jsx';
import PostGroupControl from 'app/components/PostModal/PostGroupControl.jsx';
import PostConfigPanels from 'app/components/PostModal/PostConfigPanels.jsx';
import PinterestImageUrl from 'app/components/PostModal/PinterestImageUrl.jsx';
import ErrorPanel from 'app/components/PostModal/ErrorPanel.jsx';
import LoginComponent from 'app/components/BrowserExtension/LoginComponent.jsx';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import Picker from 'emoji-picker-react';

import PostProvider from 'app/redux/Providers/PostProvider.jsx';
import SocialProvider from 'app/redux/Providers/SocialProvider.jsx';
import UtilityProvider from 'app/redux/Providers/UtilityProvider.jsx';
import QueueProvider from 'app/redux/Providers/QueueProvider.jsx';
import EverqueueProvider from 'app/redux/Providers/EverqueueProvider.jsx';
import CategoryProvider from 'app/redux/Providers/CategoryProvider.jsx';
import { compose } from 'redux';

import Utilities from 'app/utility/Utilities.js';

const urlRegex = /(\b(((https?|ftp|file|):\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

class PostModal extends React.Component {
    constructor(props) {
        super(props);

        let itemTemplate =  {
                comment: '',
                fbComment: '',
                imageLink: '',
                title: '',
                longUrl: '',
                body: ''
            };

        this.constants = this.props.app.config.constants;
        this.keyUpTimeout = 0;
        this.keyUpPasteFlag = 0;

        this.state = {
            socials: [],
            selectedSocials: [],
            posts: [{
                id: 0,
                item: itemTemplate,
                params: {
                    directShared: 0,
                    mb_id: 0,
                    postFlag: this.constants.POST_QUEUE,
                    repost: [],
                    killTs: 0,
                    delay: 0,
                    post_ts: 0,
                    tagID: 0
                },
                pinterestUrl: '',
                hasVideo: false
            }],
            activePost: 0,
            features: {
                fbMessage: false,
                imageDrop: false,
                videoDrop: false,
                panels: {
                    socials: true,
                    repeat: false,
                    everqueue: false,
                    category: false,
                    scheduler: false
                },
                postingGroups: false,
                sharedLink: false,
                pinterestImageUrl: false,
                gmb: false
            },
            errors: {
                linkPreview: '',
                post: '',
                upload: ''
            },
            linkMedia: [],
            currentAction: 'queue',
            showErrorPanel: false,
            linkPreviewLoading: false,
            lastRemovedLink: '',
            socialLocked: false,
            processing: false,
            twitterSelected: false,
            postMapped: false,
            showCommonPicker: false,
            showFBPicker: false,
            isNetworking: false
        };

        // function bindings
        this.imageToggle = this.imageToggle.bind(this);
        this.videoToggle = this.videoToggle.bind(this);
        this.linkToggle = this.linkToggle.bind(this);
        this.activateAccessory = this.activateAccessory.bind(this);
        this.buttonActions = this.buttonActions.bind(this);
        this.setPostAttribute = this.setPostAttribute.bind(this);
        this.setIsNetworking = this.setIsNetworking.bind(this);
        this.fetchSharedLink = this.fetchSharedLink.bind(this);
        this.removeSharedLink = this.removeSharedLink.bind(this);
        this.selectSocial = this.selectSocial.bind(this);
        this.postGroupToggle = this.postGroupToggle.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.selectPostGroup = this.selectPostGroup.bind(this);
        this.checkForSocialFeatures = this.checkForSocialFeatures.bind(this);
        this.togglePanel = this.togglePanel.bind(this);
        this.schedulePost = this.schedulePost.bind(this);
        this.onPostActionChange = this.onPostActionChange.bind(this);
        this.hasMedia = this.hasMedia.bind(this);
        this.postValidator = this.postValidator.bind(this);
        this.postPost = this.postPost.bind(this);
        this.mapItem = this.mapItem.bind(this);
        this.dismissErrorPanel = this.dismissErrorPanel.bind(this);
        this.onTextareaPaste = this.onTextareaPaste.bind(this);
        this.detectSharedUrl = this.detectSharedUrl.bind(this);
        this.onTextareaKeyUp = this.onTextareaKeyUp.bind(this);
        this.uploadError = this.uploadError.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.createVersion = this.createVersion.bind(this);
        this.selectVersion = this.selectVersion.bind(this);
        this.deleteVersion = this.deleteVersion.bind(this);
        this.getActivePost = this.getActivePost.bind(this);
        this.updateVersionOffsets = this.updateVersionOffsets.bind(this);
        this.setScheduleError = this.setScheduleError.bind(this);
        this.showEmojiPicker = this.showEmojiPicker.bind(this);
        this.addEmoji = this.addEmoji.bind(this);
        this.handleEmojiPickerInteraction = this.handleEmojiPickerInteraction.bind(this);

        props.getSocials();

        this.messageRef = React.createRef();
        this.fbMessageRef = React.createRef();
        this.commonEmojiRef = React.createRef();
        this.fbEmojiRef = React.createRef();

    }

    componentDidMount() {

        if (this.props) {
            this.mapItem(this.props);
        }

        this.props.clearFilter('socials');

        // if onboarding preselect the socialss
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
        if (onboarding) {
            let selectedSocials = [];
            this.props.socials.list.map((social) => {
                selectedSocials.push(social.id);
            });
            this.setState({
                selectedSocials
            });
        }

        document.addEventListener('mouseup', this.handleEmojiPickerInteraction);
        document.addEventListener('touchend', this.handleEmojiPickerInteraction);

    }

    componentDidUpdate(prevProps, prevState) {
        let post = this.getActivePost(),
            errors = this.state.errors,
            features = this.state.features,
            linkMedia = [],
            linkPreviewLoading = this.state.linkPreviewLoading,
            showErrorPanel = this.state.showErrorPanel,
            processing = this.state.processing,
            apiErrors = [],
            constants = this.props.app.config.constants;

        if (_.isEmpty(prevProps.item) && !_.isEmpty(this.props.item)) {
            this.mapItem(this.props);
        }

        if (prevProps.app.userSessionActive === false && this.props.app.userSessionActive === true) {
            this.props.getSocials();
            // did we just get logged in on the browser extension?
            // map it
            // map it good
            if (this.state.postMapped === false) {
                this.mapItem(this.props);
            }
        }

        if (prevState.selectedSocials.length !== this.state.selectedSocials.length) {
            this.checkForSocialFeatures(this.state.selectedSocials, this.props.socials.list);
        }

        if (prevProps.app.loading.UTILITIES_URL_INFO_FETCH === true && this.props.app.loading.UTILITIES_URL_INFO_FETCH === false) {
            if (!_.isEmpty(this.props.utilities.urlInfo)) {
                post.item.title = this.props.utilities.urlInfo.title;
                post.item.body = this.props.utilities.urlInfo.summary;
                if (this.props.utilities.urlInfo.media && this.props.utilities.urlInfo.media.length) {
                    post.item.imageLink = this.props.utilities.urlInfo.media[0];
                    linkMedia = this.props.utilities.urlInfo.media;
                }
                features.sharedLink = false;
            } else {
                apiErrors = this.props.getApiErrors(['UTILITIES_URL_INFO_FETCH']);
                post.item.longUrl = '';
                linkMedia = [];
                features.sharedLink = true;
                if (apiErrors.length && apiErrors[0].errors !== undefined && apiErrors[0].errors.validation !== undefined) {
                    errors.linkPreview = apiErrors[0].errors.validation.url;
                } else {
                    errors.linkPreview = "We are unable to display a preview of this page";
                }
            }


            this.setState({
                post,
                errors,
                linkPreviewLoading: false,
                linkMedia
            });
        }

        if ((prevProps.app.loading.POST_CREATE_OLD === true && this.props.app.loading.POST_CREATE_OLD === false) ||
            (prevProps.app.loading.QUEUE_UPDATE === true && this.props.app.loading.QUEUE_UPDATE === false) ||
            (prevProps.app.loading.EVERQUEUE_UPDATE === true && this.props.app.loading.EVERQUEUE_UPDATE === false)) {
            apiErrors = this.props.getApiErrors(['POST_CREATE_OLD', 'QUEUE_UPDATE', 'EVERQUEUE_UPDATE']);
            if (apiErrors.length) {
                errors.post = apiErrors[0];
                showErrorPanel = true;
                processing = false;
            } else {
                // remove onboarding flag in case someone's first action in dlvr.it is a manual post
                let onboarding = (typeof (Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
                if (onboarding !== null) {
    				window.localStorage.removeItem('onboarding');
    			}
                if (post.params.rk_pref) {
                    this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.post.success.next, 'POST_CREATE_OLD'));
                } else if (post.params.post_ts) {
                    this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.post.success.schedule, 'POST_CREATE_OLD'));
                } else if (post.params.postFlag == constants.POST_POOL) {
                    this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.post.success.everqueue, 'EVERQUEUE_UPDATE'));
                } else if (this.props.context == 'edit-everqueue') {
                    this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.post.success.everqueueEdit, 'EVERQUEUE_UPDATE'));
                } // else {
                //    this.props.addMessage(UserMessages.generateFlashMessage(UserMessages.post.success.queue, 'QUEUE_UPDATE'));
                // }
                // ^^^ the message for queue update is added in app.js
                this.closeModal();
            }

            this.setState({
                errors,
                linkMedia,
                showErrorPanel,
                processing
            });
        }

    }

    componentWillUnmount() {

        document.removeEventListener('mouseup', this.handleEmojiPickerInteraction);
        document.removeEventListener('touchend', this.handleEmojiPickerInteraction);

    }

    getActivePost() {
        let post = this.state.posts[0];

        if (this.state.activePost > 0 && this.state.posts[this.state.activePost]) {
            post = this.state.posts[this.state.activePost];
        }

        return post;
    }

    onInputChange(e) {
        let field = e.currentTarget.dataset.field,
            posts = this.state.posts,
            currentAction = this.state.currentAction,
            activePost = this.state.activePost;

        if (posts.length > 1 && (field.match("params.post_ts") || field.match("offset"))) {
            this.updateVersionOffsets(e.target.value);

            if (parseInt(e.target.value, 10) > 0 && this.state.currentAction === 'everqueue') {
                currentAction = queue;
            }
            // if scheduling is being turned off remove any active versions
            if (parseInt(e.target.value, 10) === 0) {
                activePost = 0;
                posts = [posts[0]];
            }

            this.setState({
                activePost,
                currentAction,
                posts
            }, () => {
                FormUtilityMixin.requestChange.apply(this, [e]);
            });
            return;
        }

        FormUtilityMixin.requestChange.apply(this, [e]);

    }

    uploadError(error) {
        let errors = this.state.errors,
            msg = error;

        if (error.error) {
            msg = error.errors.validation.media;
        }

        errors.upload = msg;

        this.setState({
            showErrorPanel: true,
            errors
        });

    }

    mapItem(props) {
        let posts = this.state.posts,
            post = this.state.posts[0],
            selectedSocials = this.state.selectedSocials,
            socialLocked = this.state.socialLocked,
            source = props.item,
            browserMessage = this.props.browserMessage,
            postMapped = false;

        if (this.state.postMapped) {
            return;
        }

        if (browserMessage) {
            if (browserMessage.sharedData.selectionText) {
                post.item.comment = browserMessage.sharedData.selectionText;
            }
            if (browserMessage.sharedData.url) {
                post.item.longUrl = browserMessage.sharedData.url;
                this.fetchSharedLink(post.item.longUrl);
                if (post.item.comment !== '' && !post.item.comment.match(post.item.longUrl.replace("?", "\\?"))) {
                    post.item.comment += ' ' + post.item.longUrl;
                } else {
                    post.item.comment = post.item.longUrl;
                }
            }
            if (browserMessage.sharedData.sharedImageUrl) {
                post.item.imageLink = browserMessage.sharedData.sharedImageUrl;
            }
            postMapped = true;
        } else if (source.item !== undefined) {
            post.ci_id = source.id;
            post.item = source.item;
            post.item.comment = source.item.title + " " + source.item.longUrl;
            if (source.item.killTs !== undefined) {
                post.params.killTs = source.item.killTs;
            }
            if (source.item.delay !== undefined) {
                post.params.delay = source.item.delay;
            }
            if (source.item.tagID !== undefined) {
                post.params.tagID = source.item.tagID;
            }
            if (source.item.mbID !== undefined) {
                post.params.mb_id = source.item.mbID;
            }
            if (source.item.postStyle !== undefined) {
                post.params.postStyle = source.item.postStyle;
            }
            if (source.item.gmb !== undefined) {
                post.params.gmb = source.item.gmb;
            }
            postMapped = true;
        } else if (source.preview !== undefined) {
            post.item = source.preview;
            if (source.id !== undefined) {
                post.id = source.id;
            }
            if (post.item.url !== undefined) {
                post.item.longUrl = post.item.url;
            }
            if (post.item.status !== undefined && post.item.status !== '') {
                post.item.comment = post.item.status;
            }
            if (source.paID !== undefined) {
                selectedSocials = [source.paID];
                socialLocked = true;
            }
            if (source.postafter !== undefined && parseInt(source.postafter, 10) > 0) {
                post.params.post_ts = source.postafter;
            }
            if (source.killTs !== undefined) {
                post.params.killTs = source.killTs;
            }
            if (source.delay !== undefined) {
                post.params.delay = source.delay;
            }
            if (source.tagID !== undefined) {
                post.params.tagID = source.tagID;
            }
            if (source.mbID !== undefined) {
                post.params.mb_id = source.mbID;
            }
            if (source.preview.gmb !== undefined) {
                post.params.gmb = source.preview.gmb;
            }
            postMapped = true;
        }

        if (!socialLocked && props.initialSelectedSocials) {
            selectedSocials = props.initialSelectedSocials;
        }

        posts[0] = post;

        this.setState({
            posts,
            socialLocked,
            selectedSocials,
            postMapped
        });

    }

    hasMedia() {

        let post = this.getActivePost();

        if (post.params.mb_id !== 0) {
            return true;
        } else if (post.item.imageLink !== '') {
            return true;
        }

        return false;

    }

    getCharCount() {

        let post = this.getActivePost(),
            offset = 0;

        let message = post.item.comment || '';
        let linksInMessage = message.match(urlRegex);

        if (message === '' && (post.item.fbComment !== undefined && post.item.fbComment !== '')) {
            message = post.item.fbComment;
        }

        if (linksInMessage) {
            for (let i = 0; i < linksInMessage.length; i++) {
                offset += linksInMessage[i].length - 23;
            }
        }

        return message.length - offset;

    }

    buttonActions() {
        let queueIcon = <i className="icon ion-navicon-round"/>,
            nowIcon = <i className="icon ion-forward"/>,
            nextIcon = <i className="icon ion-ios-skipforward"/>,
            everqueueIcon = <i className="ds-icon icon-everqueue"/>,
            buttons = [],
            addQLabel = 'Add to Queue';

        if (this.state.posts.length > 1) {
            addQLabel = 'Add (' + this.state.posts.length + ') to Queue';
        }

        if (this.props.context === 'new') {
            buttons = [
                {
                    action: 'queue',
                    icon: queueIcon,
                    label: addQLabel,
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'post',
                    icon: nowIcon,
                    label: 'Share Now',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'queue-next',
                    icon: nextIcon,
                    label: 'Share Next',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'everqueue',
                    icon: everqueueIcon,
                    label: 'Add to EverQueue',
                    callback: this.postPost,
                    immediate: true
                }
            ];
            // if (this.state.posts[0].params.post_ts !== 0) {
            //     buttons = [buttons[0]];
            // }
        } else if (this.props.context == 'edit-queue') {
            buttons = [
                {
                    action: 'queue',
                    icon: queueIcon,
                    label: 'Edit Post',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'post',
                    icon: nowIcon,
                    label: 'Share Now',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'queue-next',
                    icon: nextIcon,
                    label: 'Share Next',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'everqueue',
                    icon: everqueueIcon,
                    label: 'Add to EverQueue',
                    callback: this.postPost,
                    immediate: true
                }
            ];
        } else if (this.props.context == 'edit-everqueue') {
            buttons = [
                {
                    action: 'queue',
                    icon: queueIcon,
                    label: 'Edit Post',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'post',
                    icon: nowIcon,
                    label: 'Share Now',
                    callback: this.postPost,
                    immediate: true
                },
                {
                    action: 'queue-next',
                    icon: nextIcon,
                    label: 'Share Next',
                    callback: this.postPost,
                    immediate: true
                }
            ];
        }

        return buttons;

    }

    onPostActionChange(e, action, index) {
        let posts = this.state.posts,
            post = this.state.posts[0],
            now = new Date();

        switch (action.action) {
            case 'queue':
            case 'queue-next':
                post.params.postFlag = this.constants.POST_QUEUE;
                if (action.action === 'queue-next') {
                    post.params.rk_pref = 1;
                }
                break;

            case 'post':
                post.params.postFlag = this.constants.POST_NOW;
                post.params.post_ts = Math.floor(now.getTime() / 1000);
                break;

            case 'everqueue':
                post.params.postFlag = this.constants.POST_POOL;
                break;
        }

        posts[0] = post;

        this.setState({
            posts,
            currentAction: action.action
        });

    }

    schedulePost() {

        this.togglePanel('scheduler');

    }

    toggleFeature(feature) {
        let features = this.state.features,
            errors = Object.assign({}, this.state.errors);

        features[feature] = !features[feature];

        // remove shared link when the user selects photo or video
        if (feature === 'imageDrop' || feature === 'videoDrop') {
            this.removeSharedLink();
        }

        if (feature === 'imageDrop' && features[feature]) {
            features.videoDrop = false;
            features.sharedLink = false;
        } else if (feature === 'videoDrop' && features[feature]) {
            features.imageDrop = false;
            features.sharedLink = false;
        } else if (feature === 'sharedLink' && features[feature]) {
            features.imageDrop = false;
            features.videoDrop = false;
            if (errors.linkPreview) {
                delete errors.linkPreview;
            }
        }

        this.setState({
            features,
            errors
        });
    }

    imageToggle() {
        this.toggleFeature('imageDrop');
    }

    videoToggle() {
        this.toggleFeature('videoDrop');
    }

    linkToggle() {
        this.toggleFeature('sharedLink');
    }

    detectSharedUrl(value) {
        let matches,
            post = this.getActivePost(),
            posts = this.state.posts;

        if ((matches = urlRegex.exec(value)) !== null) {
            if (post.item.longUrl === '') {
                if (matches[0] !== this.state.lastRemovedLink) {
                    post.item.longUrl = matches[0];
                    this.fetchSharedLink(post.item.longUrl);
                    posts[this.state.activePost] = post;
                    this.setState({
                        posts
                    });
                }
            }
        }

    }

    fetchSharedLink(link) {

        let post = this.getActivePost();

        if (link === undefined || link.currentTarget !== undefined) {
            link = post.item.longUrl;
        }

        // if GMB is active, this is the best place to catch and set the pasted or attached
        // url
        if (this.state.posts[0].params.gmb !== undefined && this.state.posts[0].params.gmb.url === '') {
            let posts = this.state.posts;
            posts[0].params.gmb.url = link;
            this.setState({
                posts
            });
        }

        if (link !== '') {
            this.props.deleteApiError(['UTILITIES_URL_INFO_FETCH']);
            let errors = Object.assign({}, this.state.errors);
            if (errors.linkPreview) {
                delete errors.linkPreview;
            }
            this.props.getUrlInfo(encodeURIComponent(link));
            this.setState({
                linkPreviewLoading: true,
                errors
            });
        }

    }

    removeSharedLink() {
        let post = this.getActivePost(),
            posts = this.state.posts,
            lastRemovedLink = post.item.longUrl;

        post.item.title = '';
        post.item.body = '';
        post.item.imageLink = '';
        post.item.longUrl = '';
        post.item.media = [];

        if (post.params.mb_id != "0") {
            post.params.mb_id = 0;
        }

        posts[this.state.activePost] = post;

        this.setState({
            posts,
            lastRemovedLink
        });

    }

    postPost() {

        let postData = {
                accounts: [],
                posts: []
            },
            constants = this.constants;

        postData.accounts = _.clone(this.state.selectedSocials);

        postData.posts = Utilities.deepClone(this.state.posts);

        // if the item is curated remove the item from curation queue
        if (postData.ci_id !== undefined) {
            postData.ci_id = this.props.item.id;
            postData.deleteFlag = 1;
        }

        for (let i = 0; i < postData.posts.length; ++i) {
            if (postData.posts[i].params.mb_id !== 0 && postData.posts[i].pinterestUrl !== '') {
                postData.posts[i].item.longUrl = postData.posts[i].pinterestUrl;
            }
        }

        if (postData.posts[0].item.longUrl && postData.posts[0].item.longUrl !== '') {
            postData.posts[0].params.directShared = 1;
        }

        // if a post is new, it can't be scheduled and in everqueue. the everqueue tab
        // is deselected, but the user can still choose "add to everqueue" from the main
        // combo button, so make sure to set the postFlag to POST_QUEUE.
        // BUT! make sure to check this check is only performed on new posts, existing
        // scheduled posts can be copied into the everqueue
        if (parseInt(postData.posts[0].params.post_ts, 10) !== 0 && postData.posts[0].id === 0) {
            if (postData.posts[0].params.postFlag === this.constants.POST_POOL) {
                postData.posts[0].params.postFlag = this.constants.POST_QUEUE;
            }
        }

        if (this.postValidator(postData)) {
            // clear previous errors when trying to post again
            this.props.deleteApiError(['POST_CREATE_OLD', 'QUEUE_UPDATE', 'EVERQUEUE_UPDATE']);

            if (this.props.context === 'new' || (this.props.context === 'edit-queue' && postData.posts[0].params.postFlag === constants.POST_POOL)) {
                this.props.createPostV1(postData);
            } else if (this.props.context === 'edit-queue') {
                let socialId = this.state.selectedSocials[0];

                this.props.updateQueue(
                    socialId,
                    {
                        id: postData.posts[0].id,
                        item: postData.posts[0].item,
                        params: postData.posts[0].params
                    }
                );

            } else if (this.props.context === 'edit-everqueue') {
                let socialId = this.state.selectedSocials[0];

                this.props.updateEverqueue(socialId, {
                    id: postData.posts[0].id,
                    item: postData.posts[0].item,
                    params: postData.posts[0].params
                });

            }

            this.setState({
                processing: true
            });

        }

    }

    postValidator(postData) {

        let errors = [],
            stateErrors = this.state.errors,
            now = new Date(),
            test = new Date(),
            contentCheck = (item) => {
                for (let key in item) {
                    if (item[key]) {
                        return true;
                    }
                }
                return false;
            },
            hasFB = false,
            hasIG = false;

        if (postData.accounts.length === 0) {
            errors.push("At least one social needs to be selected");
        }

        if (this.state.twitterSelected && postData.accounts.length == 1) {
            if (postData.posts.length > 1) {
                errors.push("Due to Twitter’s new policy, you can not schedule duplicate posts to Twitter.")
            }
        }

        this.state.selectedSocials.map((id) => {
            let social = _.findWhere(this.props.socials.list, {id: id}),
                constants = this.props.app.config.constants;

            if (social && social.psID === constants.POST_SVC_FACEBOOK) {
                hasFB = true;
            } else if (social && social.psID === constants.POST_SVC_INSTAGRAM_BUSINESS) {
                hasIG = true;
            }
        });

        for (let i = 0; i < postData.posts.length; ++i) {
            let post = postData.posts[i];
            if (!contentCheck(post.item)) {
                errors.push("Please add some content to post.");
            }

            if (post.params.post_ts !== 0 && post.params.postFlag != this.constants.POST_NOW) {
                test.setTime(post.params.post_ts * 1000);
                if (test.getTime() < now.getTime()) {
                    errors.push("Scheduled posts need to happen in the future");
                }
            }

            if (parseInt(post.params.killTs, 10) !== 0) {
                test.setTime(post.params.killTs * 1000);
                if (test.getTime() < now.getTime()) {
                    errors.push("EverQueue posts must expire in the future");
                }
            }

            if (this.state.features.fbMessage) {
                if (contentCheck(post.item) && post.item.fbComment === '') {
                    let label = 'Facebook and Instagram require';

                    if (hasFB && !hasIG) {
                        label = "Facebook requires";
                    } else if (!hasFB && hasIG) {
                        label = "Instagram requires";
                    }

                    errors.push(`${label} that you write something to accompany your post.`);
                }
            }

            if (this.state.features.pinterestImageUrl && post.params.mb_id !== 0) {
                if (post.item.longUrl === undefined || post.item.longUrl === '') {
                    errors.push("Pinterest requires a link to accompany your media upload.");
                }
            }

            if (this.state.features.gmb) {
                if (post.params.gmb.postAction !== '' && post.params.gmb.url === '') {
                    errors.push("An update requires a link for the generated button. Find the Google Business Profile settings below by clicking the 'Google' button.");
                }
                if (_.isArray(post.params.gmb.starTime) && _.isArray(post.params.gmb.endTime)) {
                    let postType = (parseInt(post.params.gmb.postStyle, 10) === this.constants.POST_EVENT) ? 'Event' : 'Offer';
                    if (post.params.gmb.startTime[0] !== null && post.params.gmb.endTime[0] !== null) {
                        let start = new Date(post.params.gmb.startTime.join(" ")),
                            end = new Date(post.params.gmb.endTime.join(" "));

                        if (start.getTime() >= end.getTime()) {
                            errors.push("Google Business Profile " + postType + " start dates need to be prior to the end dates");
                        }
                    } else if (post.params.gmb.startTime[0] === null && post.params.gmb.endTime[0] !== null) {
                        errors.push("If you're using an end date, please provide a start date for your Google Business Profile " + postType);
                    } else if ((post.params.gmb.startTime[0] === null && post.params.gmb.startTime[1] !== null) || (post.params.gmb.endTime[0] === null && post.params.gmb.endTime[1] !== null)) {
                        errors.push("Using a time requires setting a date for your Google Business Profile " + postType);
                    } else if ((post.params.gmb.startTime[1] === null && post.params.gmb.endTime[1]) && post.params.gmb.startTime[0] === post.params.gmb.startTime[0]) {
                        errors.push("Using the same start and end date requires setting a time for your Google Business Profile " + postType);
                    }
                }
            }

            // check for pinterest accounts separately to test
            for (let index in postData.accounts) {
                let social = _.findWhere(this.props.socials.list, {id: postData.accounts[index]});
                if (social && social.psID == this.props.app.config.constants.POST_SVC_PINTEREST) {
                    if (post.params.mb_id === 0 && (post.item.imageLink !== undefined && post.item.imageLink === '')) {
                        errors.push("Pinterest requires media in a post. A text only post will be skipped.");
                    }
                }
            }
        }

        if (errors.length > 0) {
            stateErrors.post = errors;
            this.setState({
                errors: stateErrors,
                showErrorPanel: true
            });
            return false;
        }

        return true;

    }

    activateAccessory(e) {
        if (e) {

            if (e.preventDefault !== undefined) {
                e.preventDefault();
            }

            let which = e.currentTarget.dataset.accessory;

            switch(which) {
                case "social":
                    this.togglePanel('socials');
                    break;

                case "everqueue":
                    this.togglePanel('everqueue');
                    break;

                case "category":
                    this.togglePanel('category');
                    break;

                case "scheduler":
                    this.togglePanel('scheduler');
                    break;

                case "gmb":
                    this.togglePanel('gmb');
                    break;

                default:
                    break;
            }

        }
    }

    togglePanel(panel) {
        let features = this.state.features,
            visible = !features.panels[panel];

        for (let key in features.panels) {
            features.panels[key] = false;
        }
        if (visible) {
            features.panels[panel] = visible;
        } else {
            features.panels.socials = true;
        }

        this.setState({
            features
        });

    }

    setIsNetworking(value) {
        this.setState({
            isNetworking: value
        });
    }

    setPostAttribute(attribute, value) {

        let post = this.getActivePost(),
            currentAction = this.state.currentAction,
            posts = this.state.posts,
            buttons = this.buttonActions(),
            features = this.state.features;

        if (post.params.hasOwnProperty(attribute)) {
            post.params[attribute] = value;
        } else if (post.item.hasOwnProperty(attribute)) {
            post.item[attribute] = value;
        } else if (post.hasOwnProperty(attribute)) {
            post[attribute] = value;
        }

        if (attribute === 'mediaThumb') {
            if (post.item.media !== undefined) {
                if (post.item.media[0] !== undefined) {
                    post.item.media[0].thumb = value;
                } else {
                    post.item.media.push({
                        thumb: value
                    });
                }
            } else {
                post.item.media = [];
                post.item.media.push({
                    thumb: value
                });
            }
        }

        if (attribute === 'postFlag') {
            if (value == this.constants.POST_POOL || value == this.constants.POST_QUEUE) {
                for (let i = 0; i < buttons.length; ++i) {
                    if (buttons[i].label.match(/everqueue/i) && value == this.constants.POST_POOL) {
                        currentAction = 'everqueue';
                        break;
                    } else if (buttons[i].label.match(/queue/i) && value == this.constants.POST_QUEUE) {
                        currentAction = 'queue';
                        break;
                    }
                }
            }
        }

        if (attribute === 'mb_id') {
            features.imageDrop = false;
            features.videoDrop = false;
        }

        posts[this.state.activePost] = post;

        this.setState({
            posts,
            currentAction,
            features
        });

    }

    selectSocial(e) {

        let id = parseInt(e.currentTarget.dataset.id, 10) || 0,
            selectedSocials = this.state.selectedSocials,
            twitterSelected = this.state.twitterSelected,
            constants = this.constants,
            social = null;

        if (id) {
            // check for twitter and make sure only a single twitter is selected
            social = this.props.findSocial(id);

            if (social) {
                if (selectedSocials.find((socialId) => { return id === socialId; }) === undefined) {
                    if (parseInt(social.psID, 10) === constants.POST_SVC_TWITTER ) {
                        if (!twitterSelected) {
                            selectedSocials.push(id);
                            twitterSelected = true;
                        }
                    } else {
                        selectedSocials.push(id);
                    }

                } else {
                    selectedSocials.splice(selectedSocials.indexOf(id), 1);
                    twitterSelected = false;
                    for (let key in selectedSocials) {
                        social = this.props.findSocial(selectedSocials[key]);
                        if (social) {
                            if (parseInt(social.psID, 10) === constants.POST_SVC_TWITTER) {
                                twitterSelected = true;
                                break;
                            }
                        }
                    }
                }

                this.checkForSocialFeatures(selectedSocials);
                this.setState({
                    selectedSocials,
                    twitterSelected
                });
            }
        }

    }

    checkForSocialFeatures(socials, socialList) {
        let features = this.state.features,
            social = null,
            posts = this.state.posts,
            post = posts[this.state.activePost];

        if (socialList === undefined) {
            socialList = this.props.socials.list;
        }

        features.fbMessage = false;
        features.pinterestImageUrl = false;
        features.gmb = false;

        if (socials.length !== undefined) {
            for (let i = 0; i < socials.length; ++i) {
                social = _.findWhere(socialList, {id: socials[i]});
                if (social) {
                    if (social.psID == this.constants.POST_SVC_FACEBOOK || social.psID === this.constants.POST_SVC_INSTAGRAM_BUSINESS) {
                        features.fbMessage = true;
                        if (this.props.context === 'edit-queue' || this.props.context === 'edit-everqueue') {
                            if (post.item.comment && post.item.fbComment === undefined) {
                                post.item.fbComment = post.item.comment;
                                post.item.comment = '';
                            }
                        }
                    } else if (social.psID == this.constants.POST_SVC_PINTEREST) {
                        features.pinterestImageUrl = true;
                    } else if (social.psID == this.constants.POST_SVC_GMYBUSINESS) {
                        features.gmb = true;
                        if (posts[0].params.gmb === undefined) {
                            posts[0].params.gmb = {
                                postStyle: this.constants.POST_CTA,
                                postAction: this.constants.ACTION_LEARNMORE,
                                url: ''
                            };
                            if (post.item.longUrl) {
                                posts[0].params.gmb.url = post.item.longUrl;
                            }
                        }
                    }
                }
            }
        }

        posts[this.state.activePost] = post;

        this.setState({
            features,
            posts
        });

    }

    selectPostGroup(socials) {
        let features = this.state.features,
            validSocials = [];

        features.postingGroups = false;

        for (let i = 0; i < socials.length; ++i) {
            let social = this.props.findSocial(socials[i]);
            if (social) {
                validSocials.push(social.id);
            }
        }

        this.checkForSocialFeatures(validSocials);

        this.setState({
            features,
            selectedSocials: validSocials
        });

    }

    postGroupToggle(e) {
        let features = this.state.features;

        features.postingGroups = ~features.postingGroups;

        this.setState({
            features
        });

    }

    dismissErrorPanel(e) {

        this.setState({
            showErrorPanel: false
        });

    }

    onTextareaPaste(e) {
        let data;

        e.stopPropagation();

        this.keyUpPasteFlag = true;
        if ((data = e.clipboardData.getData('text/plain')) !== '') {
            this.detectSharedUrl(data);
        }

    }

    onTextareaKeyUp(e) {
        let textValue = e.target.value;

        window.clearTimeout(this.keyUpTimeout);

        // Paste was triggering both keyUp and Paste, so handle it in one with a flag
        // that determines the immediacy of the detection
        if (!this.keyUpPasteFlag) {
            this.keyUpTimeout = window.setTimeout(() => {
                this.detectSharedUrl(textValue);
                this.keyUpTimeout = 0;
            }, 1000);
        } else {
            this.keyUpPasteFlag = false;
        }
    }

    closeModal(e) {
        if (e) {
            e.preventDefault();
        }

        // second argument is for the browser extension
        if (_.isFunction(this.props.modalHandler)) {
            this.props.modalHandler.apply(this, [null, true]);
        } else {
            this.props.closeAllModals();
        }

    }

    createVersion(postTime, offset) {

        if (postTime) {
            let post = {
                    item: Utilities.deepClone(this.state.posts[0].item),
                    params: Utilities.deepClone(this.state.posts[0].params),
                    offset
                },
                posts = this.state.posts;

            post.params.post_ts = postTime;
            posts.push(post);

            posts = _.sortBy(posts, function(post) {
                return parseInt(post.params.post_ts, 10);
            });

            let activePost = _.findIndex(posts, function(post) {
                return post.params.post_ts == postTime;
            });

            this.setState({
                posts,
                activePost
            });
        }

    }

    selectVersion(e) {

        let versionIndex = e.currentTarget.dataset.versionid;

        if (versionIndex !== undefined && this.state.posts[versionIndex]) {
            this.setState({
                activePost: parseInt(versionIndex, 10)
            });
        }

    }

    deleteVersion(e) {
        let posts = this.state.posts,
            index = parseInt(e.currentTarget.dataset.versionid, 10),
            activePost = parseInt(this.state.activePost, 10);

        e.stopPropagation();

        if (index !== undefined && posts[index]) {

            posts.splice(index, 1);

            if (activePost === index || activePost >= posts.length) {
                activePost--;
            }

            this.setState({
                posts,
                activePost
            });

        }

    }

    updateVersionOffsets(baseTime) {
        let posts = this.state.posts,
            newBase = moment(baseTime * 1000).tz(this.props.user.detail.timezone);

        for (let i = 1; i < posts.length; ++i) {
            posts[i].params.post_ts = newBase.add(posts[i].offset, 'days').unix()
        }

        this.setState({
            posts
        });

    }

    setScheduleError(error) {

        this.setState({
            showErrorPanel: true,
            errors: {
                schedule: {
                    message: error
                }
            }
        });

    }

    showEmojiPicker(e) {
        let which = e.currentTarget.dataset.which,
            showCommonPicker = this.state.showCommonPicker,
            showFBPicker = this.state.showFBPicker,
            iconClick = false;

        if (e.target.className.match("fa-smile")) {
            iconClick = true;
        }

        if (which === 'common') {
            showCommonPicker = (showCommonPicker && iconClick) ? false : true;
            showFBPicker = false;
        } else {
            showFBPicker = (showFBPicker && iconClick) ? false : true;
            showCommonPicker = false;
        }

        this.setState({
            showCommonPicker,
            showFBPicker
        });
    }

    addEmoji(e, emoji) {
        let ref = (this.state.showCommonPicker) ? this.messageRef : this.fbMessageRef,
            field = (this.state.showCommonPicker) ? "posts[" + this.state.activePost + "].item.comment" : "posts[" + this.state.activePost + "].item.fbComment";

        if (ref.current) {
            let startPos = ref.current.selectionStart,
                endPos = ref.current.selectionEnd,
                nextMessage = '',
                inputChange = {
                    currentTarget: {
                        dataset: {
                            field: field
                        }
                    },
                    target: {
                        value: ''
                    }
                };

            inputChange.target.value = `${ref.current.value.substring(0, startPos)} ${emoji.emoji} ${ref.current.value.substring(endPos, ref.current.value.length)}`;

            this.onInputChange(inputChange);
        }

    }

    handleEmojiPickerInteraction(e) {

        if (this.state.showCommonPicker) {
            if (this.commonEmojiRef.current && this.commonEmojiRef.current.contains(e.target)) {
                return;
            }
            this.setState({
                showCommonPicker: false
            });
        }

        if (this.state.showFBPicker) {
            if (this.fbEmojiRef.current && this.fbEmojiRef.current.contains(e.target)) {
                return;
            }
            this.setState({
                showFBPicker: false
            });
        }

    }

    render() {

        let content,
            charCount,
            userMessage,
            facebookMessage = null,
            mediaToggles,
            media,
            configSection = null,
            previewImage = null,
            postGroupControl = null,
            classes = new SelectorTools({
                userMessages: 'user-messages',
                configMain: 'post-config',
                footer: 'post-modal-footer',
                socialButton: 'accessory-button',
                repeatButton: 'accessory-button',
                everqueueButton: 'accessory-button',
                categoryButton: 'accessory-button',
                scheduleButton: 'accessory-button',
                gmbButton: 'accessory-button',
                postGroupButton: 'fa'
            }),
            errorPanel = null,
            scheduledNotice = null,
            pinterestImageUrl = null,
            versions = null,
            post = this.getActivePost(),
            activePost = this.state.activePost,
            mainButton = null,
            gmbButton = null,
            emojiCommon = null,
            emojiFB = null;

        mediaToggles = (
            <div className="post-modal-media-toggles">
                <ul>
                    <li onClick={this.imageToggle} role="button" aria-label="add image">
                        <i className="icon ion-ios-camera-outline"/>
                    </li>
                    <li onClick={this.videoToggle} role="button" aria-label="add video">
                        <i className="icon ion-ios-videocam-outline"/>
                    </li>
                    <li onClick={this.linkToggle} role="button" aria-label="attach link">
                        <i className="icon ion-link"/>
                    </li>
                </ul>
            </div>
        );

        userMessage = (
            <textarea
                className="user-message"
                placeholder="What would you like to share?"
                ref={this.messageRef}
                onChange={this.onInputChange}
                onPaste={this.onTextareaPaste}
                onKeyUp={this.onTextareaKeyUp}
                data-field={"posts[" + activePost + "].item.comment"}
                value={post.item.comment}></textarea>
        );

        emojiCommon = (
            <div className="emoji-picker-common" onClick={this.showEmojiPicker} ref={this.commonEmojiRef} data-which="common" role="button" aria-label="add emoji">
                <i className="fa fa-smile-o"></i>
                {(this.state.showCommonPicker) ? (
                    <div className="emoji-wrapper">
                        <Picker
                            onEmojiClick={this.addEmoji}
                            native={true}/>
                    </div>
                ) : null}
            </div>
        );

        emojiFB = (
            <div className="emoji-picker-fb" onClick={this.showEmojiPicker} ref={this.fbEmojiRef} data-which="fb" role="button" aria-label="add facebook emoji">
                <i className="fa fa-smile-o"></i>
                {(this.state.showFBPicker) ? (
                    <div className="emoji-wrapper">
                        <Picker
                            onEmojiClick={this.addEmoji}
                            native={true}/>
                    </div>
                ) : null}
            </div>
        );

        charCount = (
            <div className="character-count">
                {this.getCharCount()}
                {emojiCommon}
            </div>
        );

        // put the fb emoji picker in the place of the regular emoji picker when facebook is the
        // only option available to avoid positioning issues
        if (this.state.features.fbMessage) {
            if ((this.props.context === 'edit-queue' || this.props.context === 'edit-everqueue') && this.state.socialLocked) {
                charCount = (
                    <div className="character-count">
                        {this.getCharCount()}
                        {emojiFB}
                    </div>
                );
            }
        }

        if (this.state.features.imageDrop || this.state.features.videoDrop) {
            media = (
                <div className="post-modal-user-media">
                    <PostPictureUpload
                        {...this.props}
                        activePost={activePost}
                        setPostAttribute={this.setPostAttribute}
                        setIsNetworking={this.setIsNetworking}
                        setUploadError={this.uploadError} />
                </div>
            );

        } else if (this.state.features.sharedLink) {
            media = (
                <div className="media-block">
                    <div className="shared-link">
                        <div className="field-label">
                            Link
                        </div>
                        <div className="field-wrapper">
                            <input type="text" className="shared-link-field" value={post.item.longUrl ? post.item.longUrl : ""} onChange={this.onInputChange} data-field={"posts[" +  activePost + "].item.longUrl"} />
                            <button className="shared-link-fetch" onClick={this.fetchSharedLink}>{this.state.linkPreviewLoading ? "Loading..." : "Add"}</button>
                            <div className="link-error">{this.state.errors.linkPreview}</div>
                        </div>
                    </div>
                </div>
            );
        }

        if ((post.item.longUrl && !this.state.features.sharedLink) || post.item.imageLink || (post.item.media && post.item.media.length && post.item.media[0].thumb !== "")) {
            if (this.hasMedia() && this.state.features.pinterestImageUrl) {
                pinterestImageUrl = (
                    <PinterestImageUrl
                        {...this.props}
                        post={post}
                        activePost={activePost}
                        onInputChange={this.onInputChange} />
                );
            }
            if (this.state.linkPreviewLoading) {
                media = (
                    <div className="media-block">
                        <div className="loader-block">
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                        </div>
                    </div>
                );
            } else {
                if (post.item.imageLink) {
                    previewImage = (
                        <div className="media-image">
                            <img src={post.item.imageLink}/>
                        </div>
                    );
                } else if (post.item.media && post.item.media.length && post.item.media[0].thumb !== "") {
                    previewImage = (
                        <div className="media-image">
                            <img src={post.item.media[0].thumb}/>
                        </div>
                    );
                }
                let linkPreview = null;
                if (!pinterestImageUrl && post.item.imageLink || (!post.item.imageLink && post.item.longUrl)) {
                    linkPreview = (
                        <div>
                            <div className="media-title">
                                {post.item.title}
                            </div>
                            <div className="media-summary">
                                {(post.item.comment) ? post.item.comment : post.item.body}
                            </div>
                            <div className="media-source">
                                {post.item.longUrl}
                            </div>
                        </div>
                    );
                }
                let videoWarning = null;
                if (post.hasVideo !== undefined && post.hasVideo === true) {
                    videoWarning = (
                        <div className="video-warning">
                            Currently, we only support posting videos to Twitter, Facebook and Mastodon.
                        </div>
                    );
                }
                media = (
                    <div className="media-block">
                        <div className="media-preview clearfix">
                            {previewImage}
                            {pinterestImageUrl}
                            {linkPreview}
                            {videoWarning}
                            <div className="remove-media" onClick={this.removeSharedLink} role="button" aria-label="remove media">
                                <i className="icon ion-ios-close-outline"/>
                            </div>
                        </div>
                    </div>
                );
            }

        }

        if (this.state.features.fbMessage) {
            if ((this.props.context === 'edit-queue' || this.props.context === 'edit-everqueue') && this.state.socialLocked) {
                classes.append('userMessages', 'solo-fb');
                userMessage = null;
            } else {
                classes.append('userMessages', 'split');
            }
            let icons = [],
                fb = false,
                ig = false,
                placeholder = '';

            this.state.selectedSocials.map((id) => {
                let social = _.findWhere(this.props.socials.list, {id: id}),
                    constants = this.props.app.config.constants;

                if (social && social.psID === constants.POST_SVC_FACEBOOK) {
                    fb = true;
                } else if (social && social.psID === constants.POST_SVC_INSTAGRAM_BUSINESS) {
                    ig = true;
                }
            });

            if (fb) {
                icons.push(
                    <IconFactory.facebook key="message-fb" small={true}/>
                );
            }

            if (ig) {
                icons.push(
                    <IconFactory.instagrambusiness key="message-ig" small={true}/>
                );
            }

            if (fb && !ig) {
                placeholder = "Say something about this on Facebook."
            } else if (!fb && ig) {
                placeholder = "Caption your photo for Instagram"
            } else {
                placeholder = "Say something about your post"
            }

            facebookMessage = (
                <div className="fb-message">
                    {icons}
                    <textarea
                        className="facebook-text"
                        ref={this.fbMessageRef}
                        placeholder={placeholder}
                        onChange={this.onInputChange}
                        onPaste={this.onTextareaPaste}
                        onKeyUp={this.onTextareaKeyUp}
                        data-field={"posts[" + activePost + "].item.fbComment"}
                        value={post.item.fbComment}></textarea>
                    {(userMessage !== null) ? emojiFB : null}
                </div>
            );
        }

        if (this.state.posts[0].params.post_ts > 0 && this.state.posts.length > 1) {
            versions = (
                <div className="post-versions">
                    {this.state.posts.map((post, i) => {
                        let versionClass = 'post-version',
                            deleteButton = null;

                        if (activePost === i) {
                            versionClass += ' active';
                        }

                        if (i > 0) {
                            deleteButton = (
                                <div className="post-version-delete" onClick={this.deleteVersion} data-versionid={i} role="button" aria-label="delete version">
                                    <i className="icon ion-close-round"/>
                                </div>
                            );
                        }

                        return (
                            <div className={versionClass} onClick={this.selectVersion} key={i} data-versionid={i} role="button" aria-label="select version">
                                {deleteButton}
                                <i className="icon ion-ios-clock"></i>
                                <DateDisplay
                                    dateTime={post.params.post_ts * 1000}
                                    dateTimeFormat="MM/D"
                                    useTimezone={true}
                                    user={this.props.user} />
                            </div>
                        );
                    })}
                </div>
            );

        }

        if (this.state.features.panels.socials) {
            let countLabel = (this.state.selectedSocials.length === 1) ? "social" : "socials";
            if (this.state.features.postingGroups) {
                classes.append('postGroupButton', 'fa-chevron-up');
                postGroupControl = (
                    <PostGroupControl
                        {...this.props}
                        selectedSocials={this.state.selectedSocials}
                        selectionCallback={this.selectPostGroup}
                        togglePostControl={this.postGroupToggle} />
                );
            } else {
                classes.append('postGroupButton', 'fa-chevron-right');
            }

            let socialClickHandler = this.selectSocial;
            let onlyDisplaySelectedSocials = false;
            let postGroupControl = (
                <div className="post-group-wrapper">
                    <div className="post-group-toggle" onClick={this.postGroupToggle} role="button" aria-label="show posting groups">
                        Posting Groups <i className={classes.postGroupButton}></i>
                    </div>
                    {postGroupControl}
                </div>
            );

            if (this.state.socialLocked) {
                socialClickHandler = null;
                onlyDisplaySelectedSocials = true;
                postGroupControl = null;
            }

            configSection = (
                <div className="post-modal-config social">
                    <SocialSelection
                        {...this.props}
                        displayHeader={false}
                        context="post-modal"
                        selectedSocials={this.state.selectedSocials}
                        socialClickHandler={socialClickHandler}
                        onlyDisplaySelectedSocials={onlyDisplaySelectedSocials}
                        twitterCount={this.state.twitterSelected ? 1 : 0} />
                    <div className="social-tools">
                        {scheduledNotice}
                        <div className="social-counts">
                            {this.state.selectedSocials.length} {countLabel} selected
                        </div>
                        {postGroupControl}
                    </div>
                </div>
            );
        } else {
            configSection = (
                <PostConfigPanels
                    {...this.props}
                    panels={this.state.features.panels}
                    posts={this.state.posts}
                    activePost={activePost}
                    requestChange={this.onInputChange}
                    activateAccessory={this.activateAccessory}
                    setPostAttribute={this.setPostAttribute}
                    context={this.props.context}
                    createVersion={this.createVersion}
                    setScheduleError={this.setScheduleError}
                    twitterSelected={this.state.twitterSelected} />
            );
        }

        if (this.state.selectedSocials.length) {
            classes.append('socialButton', 'active');
        }

        if (post.params.postFlag === this.constants.POST_POOL || this.props.context === 'edit-everqueue') {
            classes.append('everqueueButton', 'active');
            classes.append('scheduleButton', 'disabled');
        }

        if (parseInt(post.params.tagID, 10) !== 0) {
            classes.append('categoryButton', 'active');
        }

        if (parseInt(post.params.post_ts, 10) !== 0) {
            classes.append('scheduleButton', 'active');
            classes.append('everqueueButton', 'disabled');
        }

        if (this.state.features.panels.socials) {
            classes.append('socialButton', 'active');
        } else if (this.state.features.panels.repeat) {
            classes.append('repeatButton', 'active');
        } else if (this.state.features.panels.everqueue) {
            classes.append('everqueueButton', 'active');
        } else if (this.state.features.panels.category) {
            classes.append('categoryButton', 'active');
        } else if (this.state.features.panels.scheduler) {
            classes.append('scheduleButton', 'active');
        } else if (this.state.features.panels.gmb) {
            classes.append('gmbButton', 'active');
        }

        if (this.state.showErrorPanel) {
            if (this.state.errors.post) {
                errorPanel = (
                    <ErrorPanel
                        constants={this.constants}
                        errorHeader="Oh no! We can't post your item as is..."
                        error={this.state.errors.post}
                        dismissError={this.dismissErrorPanel}
                        pubLevel={this.props.user.detail.pubLevel} />
                );
            } else if (this.state.errors.upload) {
                errorPanel = (
                    <ErrorPanel
                        constants={this.constants}
                        errorHeader="There's a problem with your media..."
                        error={this.state.errors.upload}
                        dismissError={this.dismissErrorPanel}
                        pubLevel={this.props.user.detail.pubLevel} />
                );
            } else if (this.state.errors.schedule) {
                errorPanel = (
                    <ErrorPanel
                        constants={this.constants}
                        errorHeader="There's a problem with your schedule..."
                        error={this.state.errors.schedule}
                        dismissError={this.dismissErrorPanel}
                        pubLevel={this.props.user.detail.pubLevel} />
                );
            }
        }

        if (this.state.processing || this.state.isNetworking || this.state.linkPreviewLoading) {
            mainButton = (
                <div className="combo-button">
                    <div className="working">
                        <i className="fa fa-circle-o-notch fa-spin"></i>
                    </div>
                </div>
            );
        } else {
            mainButton = (
                <ComboButton
                    actions={this.buttonActions()}
                    selectActionCallback={this.onPostActionChange}
                    selectedAction={this.state.currentAction} />
            );
        }

        if (this.state.features.gmb) {
            gmbButton = (
                <div className={classes.gmbButton} onClick={this.activateAccessory} data-accessory="gmb" role="button" aria-label="Google">
                    <div className="accessory-icon">
                        <i className="ds-icon icon-gmb"/>
                    </div>
                    <div className="accessory-label" alt="Google Business Profile">
                        Google
                    </div>
                </div>
            );
        }

        content = (
            <div className="post-modal-wrapper">
                {errorPanel}
                {versions}
                <div className={classes.userMessages}>
                    {userMessage}
                    {facebookMessage}
                    {charCount}
                    {mediaToggles}
                </div>
                {media}
                <div className={classes.configMain}>
                    {configSection}
                </div>
                <div className={classes.footer}>
                    <div className="accessory-buttons">
                        <div className={classes.socialButton} onClick={this.activateAccessory} data-accessory="social" role="button" aria-label="socials">
                            <div className="accessory-icon">
                                <i className="icon ion-ios-people"/>
                            </div>
                            <div className="accessory-label">
                                Socials
                            </div>
                        </div>
                        <div className={classes.scheduleButton} onClick={(this.props.context === 'edit-everqueue') ? null : this.activateAccessory} data-accessory="scheduler" role="button" aria-label="schedule">
                            <div className="accessory-icon">
                                <i className="icon ion-ios-calendar-outline"/>
                            </div>
                            <div className="accessory-label">
                                Schedules
                            </div>
                        </div>
                        <div className={classes.categoryButton} onClick={this.activateAccessory} data-accessory="category" role="button" aria-label="category">
                            <div className="accessory-icon">
                                <i className="icon ion-ios-pricetag-outline"/>
                            </div>
                            <div className="accessory-label">
                                Category
                            </div>
                        </div>
                        <div className={classes.everqueueButton} onClick={(parseInt(post.params.post_ts, 10) !== 0) ? null : this.activateAccessory} data-accessory="everqueue" role="button" aria-label="everqueue">
                            <div className="accessory-icon">
                                <i className="ds-icon icon-everqueue"/>
                            </div>
                            <div className="accessory-label">
                                EverQueue
                            </div>
                        </div>
                        {gmbButton}
                    </div>
                    <div className="primary-action">
                        <div className="button-wrapper">
                            {mainButton}
                        </div>
                    </div>
                </div>
            </div>
        );

        // for the browser extension -- show login panel if user needs to be logged in
        if (this.props.showLogin) {
            content = (
                <LoginComponent
                    {...this.props}
                    loginUser={this.props.loginUser}
                    socialLogin={this.props.socialLogin}
                    loginErrors={this.props.loginErrors}/>
            );
        }


        return (
            <Modal
                boxClass="post-modal"
                showClose={true}
                close={this.closeModal}
                headerContent="Share Something Excellent"
                content={content} />
        );
    }
};

PostModal.displayName = "PostModal";

PostModal.propTypes = {
    context: PropTypes.string,
    user: PropTypes.object,
    userPerms: PropTypes.object,
    action: PropTypes.string,
    item: PropTypes.object,
    modalHandler: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ]),
    postAction: PropTypes.func,
    showLogin: PropTypes.bool,
    loginUser: PropTypes.func,
    socialLogin: PropTypes.func,
    loginErrors: PropTypes.string,
    browserMessage: PropTypes.object
};

PostModal.defaultProps = {
    context: 'new',
    user: {},
    userPerms: {},
    action: '',
    item: {},
    postAction: null,
    modalHandler: null,
    showLogin: false,
    loginUser: () => {},
    socialLogin: () => {},
    loginErrors: '',
    browserMessage: null
};

const enhance = compose(
    PostProvider,
    SocialProvider,
    QueueProvider,
    EverqueueProvider,
    UtilityProvider,
    CategoryProvider
);

export default enhance(PostModal);
